module.exports = __webpack_public_path__ + "media/VocnaNargila.c78d9d35.webm";